<ng-container>
  <app-modal [width]="modalWidth" [classType]="'white'" [zindex]="3">
    <div content>

      <div class="header">
        <div class="icon-content">
          <i aria-hidden="true" class="icon-close" (click)="confirmDeleteAlert.emit(false)"></i>
        </div>
      </div>

      <div class="icon-notification-content">
        <img class="icon-notification" loading="lazy" [src]="ALERT_NOTIFICATION | ImageCdn">
      </div>

      <div class="message-content">
        <span class="principal">
          {{ 'GENERAL_WIDGET_MODULE.ALERTS.DELETE.CONFIRM_MESSAGE' | transloco }}
        </span>
      </div>

      <div class="actions">
        <div class="button-container">
          <div class="remove-alert">
            <app-ds-button
              [type]="cancelButtonType"
              [labels]="{ ButtonLabel: 'GENERAL_WIDGET_MODULE.ALERTS.DELETE.CONFIRM_REMOVE' | transloco }"
              (clickEvent)="confirmDeleteAlert.emit(true)">
            </app-ds-button>
          </div>
          <app-ds-button
            class="cancel-button"
            [labels]="{ ButtonLabel: 'GENERAL_WIDGET_MODULE.ALERTS.DELETE.CANCEL' | transloco | transloco }"
            (clickEvent)="confirmDeleteAlert.emit(false)">
          </app-ds-button>
        </div>
      </div>

    </div>
  </app-modal>
</ng-container>
